export default __webpack_public_path__ + "static/media/founder3.e5c16d24.jpg";